// src/pages/Team.js
import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Text,
  Stack,
  Button,
  Image,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function Team() {
  const { t } = useTranslation();

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Box
      id="team"
      bg="white"
      color="black"
      py={{ base: 6, md: 12 }}
      scrollMarginTop={{ base: 84, md: 110 }}
    >
      <Container maxW="container.xl">
        <Grid
          templateColumns={{ base: "1fr", md: "1fr 1fr" }}
          gap={{ base: 8, md: 12, lg: 16 }}
          alignItems="center"
        >
          {/* Αριστερά: Κείμενο και κουμπιά */}
                <GridItem>
                <Stack spacing={5}>
                  <Heading size={{ base: "xl", md: "2xl" }}>{t("team_title")}</Heading>
                  <Text fontSize={{ base: "md", md: "lg" }} opacity={0.9}>
                    {t("team_description")}
                  </Text>
                  <Stack direction={{ base: "column", sm: "row" }} spacing={4} pt={2}>
                  <Button
                    size="lg"
                    backgroundColor="black"
                    color="white"
                    _hover={{ backgroundColor: "gray.700" }}
                    onClick={() => goTo("contact")}
                  >
                    {t("team_join")}
                  </Button>
                  <Button
                    as="a"
                    href="mailto:geo_stefanidis@hotmail.com"
                    size="lg"
                    variant="outline"
                  >
                    {t("team_email")}
                  </Button>
                  <Button
                    as="a"
                    href="/Pelopos_Patron.pdf"
                    download
                    size="lg"
                    variant="outline"
                    colorScheme="blue"
                  >
                    {t("team_pdf")}
                  </Button>
                  </Stack>
                </Stack>
                </GridItem>

                {/* Δεξιά: Εικόνα */}
          <GridItem>
            <Box
              borderRadius="2xl"
              overflow="hidden"
              boxShadow="0 20px 60px rgba(0,0,0,0.35)"
            >
              <Image
                src="/logo-team.jpg" // βάλε την εικόνα σου στο public/
                alt="Team Logo"
                w="100%"
                h={{ base: "240px", sm: "300px", md: "360px", lg: "420px" }}
                objectFit="contain"
              />
            </Box>
          </GridItem>
        </Grid>
      </Container>
    </Box>
  );
}
